import { useEffect, useRef, useState } from "react";

export interface ProgressEvent {
  job: string;
  jobId?: number;
  step: string;
  detail?: string;
  percent: number;
  at: number;
  memoryMB: { rss: number; heapUsed: number };
  // Richer apply/sync fields (counts + API estimate + start time) — optional.
  total?: number;
  processed?: number;
  failed?: number;
  apiEstimate?: number;
  startedAt?: number;
  changeSetId?: number;
}

/** Subscribe to the server's /api/progress SSE stream; track latest event per job + a rolling log. */
export function useProgressStream() {
  const [byJob, setByJob] = useState<Record<string, ProgressEvent>>({});
  const [log, setLog] = useState<ProgressEvent[]>([]);
  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    const es = new EventSource("/api/progress");
    esRef.current = es;
    es.onmessage = (e) => {
      try {
        const ev = JSON.parse(e.data) as ProgressEvent;
        if (!ev.job) return;
        setByJob((prev) => ({ ...prev, [ev.job]: ev }));
        setLog((prev) => [...prev.slice(-300), ev]);
      } catch {
        /* ignore keep-alives */
      }
    };
    es.onerror = () => {
      /* EventSource auto-reconnects */
    };
    return () => es.close();
  }, []);

  return { byJob, log };
}
